(() => {
  'use strict';

  let busy = false;

  const triggerCartIconClick = () => {
    const cartIcon = document.getElementById('cart-icon-bubble') || document.querySelector('.header__icon--cart');
    if (cartIcon) cartIcon.click();
  };

  const getSelectedBottleItems = () =>
    [...document.querySelectorAll('.empty-bottles-addon__checkbox:checked')]
      .map((checkbox) => parseInt(checkbox.value, 10))
      .filter((id) => id && !Number.isNaN(id))
      .map((id) => ({ id, quantity: 1 }));

  // Same "₹1,234" rule as snippets/descaler-rupee-price.liquid (whole rupees, else 2 decimals).
  const formatRupees = (cents) => {
    const amount = cents % 100 === 0 ? cents / 100 : Math.round(cents) / 100;
    return `₹${amount}`;
  };

  // Shows base variant price + checked add-ons in the main ATC button; the sticky ATC bar mirrors that price.
  const updateButtonTotal = () => {
    document.querySelectorAll('.main-product__atc-btn').forEach((button) => {
      const priceEl = button.querySelector('.main-product__atc-btn-price');
      const baseCents = parseInt(button.dataset.priceCents, 10);
      if (!priceEl || Number.isNaN(baseCents)) return;

      const addonCents = [...document.querySelectorAll('.empty-bottles-addon__checkbox:checked')].reduce(
        (sum, checkbox) => sum + (parseInt(checkbox.dataset.priceCents, 10) || 0),
        0
      );
      priceEl.textContent = formatRupees(baseCents + addonCents);
    });
  };

  const init = () => {
    document.addEventListener('change', (event) => {
      if (event.target.closest('.empty-bottles-addon__checkbox')) updateButtonTotal();
    });
    // Fired after a variant change re-renders the button with the base price.
    document.addEventListener('addon-total:refresh', updateButtonTotal);
    updateButtonTotal();

    document.addEventListener(
      'click',
      async (event) => {
        if (busy) return;

        const submitButton = event.target.closest('button[type="submit"][name="add"], button.product-form__submit');
        if (!submitButton) return;

        const productForm = submitButton.closest('product-form');
        if (!productForm) return;

        const bottleItems = getSelectedBottleItems();
        if (bottleItems.length === 0) return;

        const form = productForm.querySelector('form');
        const variantInput = form && form.querySelector('[name="id"]');
        if (!form || !variantInput || variantInput.disabled) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        busy = true;

        const errorWrap = productForm.querySelector('.product-form__error-message-wrapper');
        const errorMessage = productForm.querySelector('.product-form__error-message');
        const spinner = submitButton.querySelector('.loading__spinner');
        if (errorWrap) errorWrap.setAttribute('hidden', '');
        if (spinner) spinner.classList.remove('hidden');

        let mainProductSubmitted = false;

        try {
          const response = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({ items: bottleItems }),
          });
          const data = await response.json().catch(() => ({}));

          if (!response.ok || data.status) {
            const message = data.description || data.message || 'Could not add the selected bottles to cart.';
            if (errorMessage) errorMessage.textContent = message;
            if (errorWrap) errorWrap.removeAttribute('hidden');
            return;
          }

          document.querySelectorAll('.empty-bottles-addon__checkbox:checked').forEach((checkbox) => {
            checkbox.checked = false;
          });
          updateButtonTotal();

          mainProductSubmitted = true;
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit(submitButton);
          } else {
            form.submit();
          }
          setTimeout(triggerCartIconClick, 900);
        } catch (error) {
          console.error('[empty-bottles-addon] add-on failed:', error);
          if (errorMessage) errorMessage.textContent = 'Something went wrong. Please try again.';
          if (errorWrap) errorWrap.removeAttribute('hidden');
        } finally {
          if (!mainProductSubmitted && spinner) spinner.classList.add('hidden');
          busy = false;
        }
      },
      true
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
